import { toast } from "sonner";
import baseApi from "store/api/baseApi";

const userManagementApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    // Get all users
    getAllUsers: builder.query({
      query: () => ({
        url: "qwikITUser/",
        method: "GET",
      }),
      providesTags: ["users"],
      transformResponse: response => (Array.isArray(response) ? response.slice().reverse() : response),
    }),

    // Get a single user by ID
    getUser: builder.query({
      query: id => ({
        url: `qwikITUser/${id}/`,
        method: "GET",
      }),
      providesTags: ["users"],
      transformResponse: response => response,
    }),

    // Get full user details (including projects, employee profile, salary, payroll, attendance, tasks, targets)
    getUserDetails: builder.query({
      query: id => ({
        url: `qwikITUser/${id}/details/`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [{ type: "users", id: `details-${id}` }],
      transformResponse: response => response,
    }),

    // Create a new user
    createUser: builder.mutation({
      query: data => ({
        url: "qwikITUser/new/",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["users"],
      transformResponse: response => {
        toast.success("User created successfully");
        return response;
      },
    }),

    updateUser: builder.mutation({
      query: ({ id, formData }) => ({
        url: `qwikITUser/${id}/`,
        method: "PATCH",
        body: formData,
        headers: {},
      }),
      invalidatesTags: ["users"],
      transformResponse: response => {
        toast.success("User updated successfully");
        return response;
      },
    }),

    // Delete user
    deleteUser: builder.mutation({
      query: id => ({
        url: `qwikITUser/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["users"],
      transformResponse: response => {
        toast.success("User deleted successfully");
        return response;
      },
    }),
  }),
});

export const {
  useGetAllUsersQuery,
  useGetUserQuery,
  useGetUserDetailsQuery,
  useLazyGetUserDetailsQuery,
  useCreateUserMutation,
  useUpdateUserMutation,
  useDeleteUserMutation,
} = userManagementApi;
